import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Util from '../../script/util';
import iconDiamondPNG from './img/diamond-icon.png';
import iconCouponPNG from './img/ico-coupon.png';

class PrizeItem extends Component {
  renderNumber = (item) => {
    const { rewardNum, unit, validEtime } = item;

    let unitText = '';
    switch (Number(unit)) {
      case 0:
        unitText = `${rewardNum}天`;
        break;
      case 1:
        unitText = `${rewardNum}小时`;
        break;
      case 2:
        unitText = `x${rewardNum}`;
        break;
      case 3:
        unitText = validEtime;
        break;
      default:
        unitText = `${rewardNum}天`;
        break;
    }
    if (rewardNum < 0) {
      unitText = `永久`;
    }

    return <span className="prize-num">{unitText}</span>;
  };

  render() {
    const { item } = this.props;

    return (
      <li className="prize-item">
        <div className="prize-content">
          {this.renderNumber(item)}
          <div className="prize-img">
            {item.rewardType === 5 ? (
              <img src={iconDiamondPNG} alt="钻石" />
            ) : item.rewardType === 8 ? (
              <img src={iconCouponPNG} alt="优惠券" />
            ) : (
              <img
                src={Util.transImgUrl(item.rewardPic)}
                alt={item.rewardName}
              />
            )}
          </div>
          <p className="prize-name">{item.rewardName}</p>
          <p className="price-num">
            {item.rewardAmount ? (
              <span>{item.rewardAmount}钻</span>
            ) : (
              <span>&nbsp;</span>
            )}
          </p>
        </div>
      </li>
    );
  }
}

export default withRouter(PrizeItem, { withRef: true });
